import styled from "styled-components"
import RowSolicitud from './rowSolicitud.jsx'

const Container=styled.div`
	display:flex;
	flex-wrap:wrap;	
	justify-content:space-around;
	align-items:center;
	color:white;
`;

const ContainerSolicitud=styled.div`
	margin:10px;
	transition:all 110ms;
	&:hover{
		scale:1.05
	}
`;



export default function CambioPrecio(props){
	let { solicitudes } = props;
	
	return(
		<Container >
			{solicitudes?
	 				solicitudes.map(solicitud=>
	 							<ContainerSolicitud  key={solicitud.id}>
	 								<RowSolicitud solicitud={solicitud} /> 						

	 							</ContainerSolicitud> ):<div>no data</div>   }
		</Container>
	)
}